export default __webpack_public_path__ + "static/media/20-2.56209cbf.mp3";